import { useAuthStore } from '@/store/modules/auth';
import { useKycStore } from '@/store/modules/kyc';
import useTransactionsStore from '@/store/modules/transactions';
export const logoutUser = () => {
    const auth = useAuthStore();
    const transaction = useTransactionsStore();
    const kyc = useKycStore();
    auth.resetStore();
    transaction.resetStore();
    transaction.userTransactions.splice(0);
    kyc.resetStore();
};
export const logoutUserAndPartner = () => {
    const auth = useAuthStore();
    const transaction = useTransactionsStore();
    const kyc = useKycStore();
    auth.resetUserAndPartnerStore();
    transaction.resetUserAndPartnerStore();
    transaction.userTransactions.splice(0);
    kyc.resetStore();
};
